import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-upload-show-choice',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './upload-show-choice.component.html',
  styleUrl: './upload-show-choice.component.css'
})
export class UploadShowChoiceComponent {
  @Input() selectedOption: string = 'upload';
  @Output() selectedOptionChange: EventEmitter<string> = new EventEmitter<string>();

  selectOption(option: string): void {
    this.selectedOption = option;
    this.selectedOptionChange.emit(this.selectedOption);
  }
}
